// translations/pages/team/bg.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageBG = {
  hero: {
    title: 'Екип',
    intro: 'Adrian Eisenmeier и Nikolai Genov основаха pAIoneer Labs GmbH и го ръководят като управители.',
    members: 'Adrian Eisenmeier е дипломиран физик и разработва системи там, където изкуственият интелект, софтуерната архитектура, защитата на данните и сигурността се срещат. Nikolai Genov е доктор по биоинформатика и технически ръководител за софтуерна разработка с помощта на ИИ и анализи в регулираните сектори здравеопазване, науки за живота и финанси. Alina Tselinina е софтуерен разработчик и инженер по данни с магистърска степен по финансова и актюерска математика и разработва приложения, REST API и пайплайни за данни на Python и R.'
  },
  card: {
    cta: 'Вижте профила'
  },
  profile: {
    overview: 'Екип',
    membersLabel: 'Членове на екипа'
  }
};
